var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoatPlayerPecheur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323.45,
    height: 188.73,
    viewBox: "0 0 323.45 188.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BOAT_PLAYER",
    "data-name": "BOAT PLAYER",
    transform: "translate(-195.281 153.095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "FOND_TRANSPARENT",
    "data-name": "FOND TRANSPARENT",
    width: 323.45,
    height: 188.73,
    transform: "translate(195.281 -153.095)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3302",
    "data-name": "Group 3302",
    transform: "translate(300.277 -146.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7219",
    "data-name": "Path 7219",
    d: "M268.147,132.292H208.494l.715-.666c.2-.186,20.033-18.735,39.8-36.991,40.184-37.078,40.971-36.864,41.527-36.7l-.342.746.167-.373.1.379c-2.765,1.059-57.873,52.264-79.836,72.8h56.784l22.432-67.91.922.213Z",
    transform: "translate(-208.494 -57.915)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1322",
    "data-name": "Rectangle 1322",
    width: 71.575,
    height: 32.383,
    rx: 0.811,
    transform: "translate(418.335 -36.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3303",
    "data-name": "Group 3303",
    transform: "translate(198.858 -153.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7220",
    "data-name": "Path 7220",
    d: "M437,206.58l-.151-.013L195.731,180.289l.874-.586L379.068,56.932l.3.266L512.144,174.21l-.572.246ZM198.075,179.743,436.83,205.755l73.742-31.771L378.98,58.017Z",
    transform: "translate(-195.731 -56.932)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1323",
    "data-name": "Rectangle 1323",
    width: 7.678,
    height: 161.454,
    transform: "translate(378.311 -147.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3316",
    "data-name": "Group 3316",
    transform: "translate(195.281 -73.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7221",
    "data-name": "Path 7221",
    d: "M203.386,115.245,218,73.906c1.041-2.949,4.275-4,7.946-4h89.92c2.5,0,4.863-.027,6.436,1.6l35.043,53.935Z",
    transform: "translate(-138.98 -68.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3305",
    "data-name": "Group 3305",
    transform: "translate(0 29.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3304",
    "data-name": "Group 3304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7222",
    "data-name": "Path 7222",
    d: "M211.485,127.215c4.664,3.442,7.628,25.187,34.829,25.187H438.137c63.388,0,77.858-60.586,80.567-76.545.278-1.651-1.677-2.9-3.52-2.277-10.37,3.535-41.543,12-104.724,13.256-80.162,1.6-213.294-6-213.294-6S187.622,109.625,211.485,127.215Z",
    transform: "translate(-195.281 -72.443)",
    fill: "#d14f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8728",
    "data-name": "Path 8728",
    d: "M438.137,152.4c63.388,0,77.858-60.586,80.567-76.545.278-1.651-1.677-2.9-3.52-2.277-10.37,3.535-48.217,11.285-64.971,11.41C512.548,83.212,438.137,152.4,438.137,152.4Z",
    transform: "translate(-195.281 -72.443)",
    fill: "#dd6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7223",
    "data-name": "Path 7223",
    d: "M411.488,97.541c61.449-1.205,93.186-8.928,105.209-12.71.93-3.655,1.549-6.758,1.923-8.975.278-1.651-1.677-2.9-3.52-2.277-10.37,3.535-41.543,12-104.724,13.256-80.162,1.6-213.294-6-213.294-6a46.968,46.968,0,0,0-1.788,10.792C210.447,92.454,334.743,99.039,411.488,97.541Z",
    transform: "translate(-195.196 -73.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7224",
    "data-name": "Path 7224",
    d: "M517,81c-12.023,3.782-43.76,11.511-105.209,12.71-76.745,1.5-201.041-5.087-216.2-5.912.1-1.638.254-3.136.445-4.474a52.263,52.263,0,0,0-.739,6.325c15.154.826,139.449,7.41,216.195,5.912,61.449-1.205,93.186-8.928,105.209-12.71.93-3.655,1.549-6.758,1.923-8.975.008-.04-.024-.067-.016-.107C518.23,75.763,517.706,78.213,517,81Z",
    transform: "translate(-195.196 -70.459)",
    fill: "#edb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7225",
    "data-name": "Path 7225",
    d: "M514.085,73.579c-10.37,3.535-41.543,12-104.724,13.256-80.162,1.6-213.294-6-213.294-6s-.286.9-.628,2.417c5.554.313,134.6,7.543,213.032,5.979,63.181-1.258,94.346-9.72,104.716-13.249,1.844-.633,3.806.619,3.52,2.27-.294,1.738-.739,4.021-1.359,6.678l.334-.1c.93-3.655,1.549-6.758,1.923-8.975C517.884,74.205,515.929,72.954,514.085,73.579Z",
    transform: "translate(-194.182 -73.415)",
    fill: "#edb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7226",
    "data-name": "Path 7226",
    d: "M197.32,84.557c4.664,3.442,7.628,25.187,34.829,25.187H423.972c29.513,0,48.417-13.136,60.471-28.789C418.728,90.7,319.383,98.119,197.32,84.557Z",
    transform: "translate(-181.116 -29.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7227",
    "data-name": "Path 7227",
    d: "M481.2,84.876c1.121-1.285,2.217-2.59,3.242-3.922-65.716,9.74-165.06,17.164-287.123,3.6a12.005,12.005,0,0,1,2.686,3.735C318.89,101.235,415.978,94.317,481.2,84.876Z",
    transform: "translate(-181.116 -29.785)",
    fill: "#edb8b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3315",
    "data-name": "Group 3315",
    transform: "translate(90.504 5.572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1337",
    "data-name": "Rectangle 1337",
    width: 10.147,
    height: 10.451,
    rx: 0.245,
    transform: "translate(0)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338",
    "data-name": "Rectangle 1338",
    width: 8.51,
    height: 8.862,
    rx: 0.206,
    transform: "translate(0.818 0.795)",
    fill: "#66bdcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3318",
    "data-name": "Group 3318",
    transform: "translate(108.19 5.572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1337-2",
    "data-name": "Rectangle 1337",
    width: 10.147,
    height: 10.451,
    rx: 0.245,
    transform: "translate(0)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338-2",
    "data-name": "Rectangle 1338",
    width: 8.51,
    height: 8.862,
    rx: 0.206,
    transform: "translate(0.818 0.795)",
    fill: "#66bdcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3319",
    "data-name": "Group 3319",
    transform: "translate(125.876 5.572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1337-3",
    "data-name": "Rectangle 1337",
    width: 10.147,
    height: 10.451,
    rx: 0.245,
    transform: "translate(0)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338-3",
    "data-name": "Rectangle 1338",
    width: 8.51,
    height: 8.862,
    rx: 0.206,
    transform: "translate(0.818 0.795)",
    fill: "#66bdcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3320",
    "data-name": "Group 3320",
    transform: "translate(143.562 5.572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1337-4",
    "data-name": "Rectangle 1337",
    width: 10.147,
    height: 10.451,
    rx: 0.245,
    transform: "translate(0)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338-4",
    "data-name": "Rectangle 1338",
    width: 8.51,
    height: 8.862,
    rx: 0.206,
    transform: "translate(0.818 0.795)",
    fill: "#66bdcc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3321",
    "data-name": "Group 3321",
    transform: "translate(161.248 5.572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1337-5",
    "data-name": "Rectangle 1337",
    width: 10.147,
    height: 10.451,
    rx: 0.245,
    transform: "translate(0)",
    fill: "#42647a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338-5",
    "data-name": "Rectangle 1338",
    width: 8.51,
    height: 8.862,
    rx: 0.206,
    transform: "translate(0.818 0.795)",
    fill: "#66bdcc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7244",
    "data-name": "Path 7244",
    d: "M309.236,72.241l-.493-.766a8.993,8.993,0,0,0-6.436-2.57h-89.92a8.7,8.7,0,0,0-7.048,3.336Z",
    transform: "translate(-125.421 -68.905)",
    fill: "#d14f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7245",
    "data-name": "Path 7245",
    d: "M205.266,70.338H310.34l-.6-.932h-103.9A6.887,6.887,0,0,0,205.266,70.338Z",
    transform: "translate(-125.921 -66.07)",
    fill: "#edb8b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3496",
    "data-name": "Group 3496",
    transform: "translate(365.166 -152.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7246",
    "data-name": "Path 7246",
    d: "M248.715,61.553H218.448a1.66,1.66,0,0,1-1.788-1.5h0a1.665,1.665,0,0,1,1.788-1.5h30.268a1.665,1.665,0,0,1,1.788,1.5h0A1.66,1.66,0,0,1,248.715,61.553Z",
    transform: "translate(-216.66 -48.284)",
    fill: "#d14f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7247",
    "data-name": "Path 7247",
    d: "M221.082,63.406h0a2.428,2.428,0,0,1-2.614-2.19V59.2a2.428,2.428,0,0,1,2.614-2.19h0A2.436,2.436,0,0,1,223.7,59.2v2.011A2.436,2.436,0,0,1,221.082,63.406Z",
    transform: "translate(-204.101 -57.014)",
    fill: "#d14f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7248",
    "data-name": "Path 7248",
    d: "M237.105,59.53H218.583a1.012,1.012,0,0,1-1.1-.919h0a1.012,1.012,0,0,1,1.1-.912h18.523a1.012,1.012,0,0,1,1.1.912h0A1.012,1.012,0,0,1,237.105,59.53Z",
    transform: "translate(-210.922 -53.138)",
    fill: "#d14f4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1339",
    "data-name": "Rectangle 1339",
    width: 19.186,
    height: 28.585,
    rx: 0.723,
    transform: "translate(8.096 23.866)",
    fill: "#d14f4f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatPlayerPecheur);
export default __webpack_public_path__ + "static/media/boat-player-pecheur.c1909bda.svg";
export { ForwardRef as ReactComponent };